import React from 'react';
import { Styler } from '@honeycomb/ui-core';
import { TripType } from '@honeycomb/data';
import { HolidayFunnelStepper } from './HolidayFunnelStepper';
import { HotelFunnelStepper } from './HotelFunnelStepper';
import { TransferFunnelStepper } from './TransferFunnelStepper';
import { FunnelStepperSkeleton } from './FunnelStepperSkeleton';
import { FlightFunnelStepper } from './FlightFunnelStepper';
export function FunnelStepper(props) {
    const { tripType, funnelStep, queryString, estabId, hasMandatoryTransfer, hasHotelOptionalTransfer, loading } = props;
    if (loading) {
        // Render skeleton loading state.
        return React.createElement(FunnelStepperSkeleton, null);
    }
    if (!tripType) {
        // Trip type not known
        return null;
    }
    return (React.createElement(Styler, { pt: 5, mb: 4 },
        tripType === TripType.Holiday && (React.createElement(HolidayFunnelStepper, { queryString: queryString, funnelStep: funnelStep, estabId: estabId, hasMandatoryTransfer: hasMandatoryTransfer })),
        tripType === TripType.Hotel && (React.createElement(HotelFunnelStepper, { queryString: queryString, funnelStep: funnelStep, estabId: estabId, hasMandatoryTransfer: hasMandatoryTransfer, hasHotelOptionalTransfer: hasHotelOptionalTransfer })),
        tripType === TripType.Flight && React.createElement(FlightFunnelStepper, { queryString: queryString, funnelStep: funnelStep }),
        tripType === TripType.Transfer && (React.createElement(TransferFunnelStepper, { funnelStep: funnelStep, queryString: queryString }))));
}
